import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import InfiniteCarousel from "../components/shared/InfiniteCarousel";
import Tags, {tags} from "../components/shared/Tags";
import Button from "@mui/material/Button";

import ExpAone from "../images/experiences/exp_aone.webp"
import ExpInbattle from "../images/experiences/exp_inbattle.webp"
import ExpPixanoh from "../images/experiences/exp_pixanoh.webp"
import ExpPlayme from "../images/experiences/exp_playme.webp"
import ExpSneakybox from "../images/experiences/exp_sneakybox.webp"


const ExperienceCard = ({experience}) => {
    const { t } = useTranslation();

    return (
        <article className={'project-card'}>
            <div className={'project-card-media'}>
                <div className={'experience-image-carousel'}>
                    <img alt={''} className={'project-card-image'} src={experience.logo}/>
                </div>
            </div>
            <div className={"project-card-content"}>
                <h2 className={"project-card-title"}>{experience.company}</h2>
                <div className={'experience-card-subtitle'}>
                    <span className={"experience-card-position"}>{experience.position} <span className={"experience-card-date"}>/{experience.since}-{experience.until}</span></span>
                </div>

                <Tags tags={experience.tags}/>
                <p className={'experience-card-description'}>{experience.description}</p>

                <div className="project-card-footer">
                    <Button
                        color="success"
                        variant="contained"
                        className="project-card-link"
                        onClick={() => window.open(experience.link, '_blank', 'noopener,noreferrer')}
                    >
                        {t('experienceLink')}
                    </Button>
                </div>
            </div>
        </article>
    )
};

const Experiences = ({ isActive = false }) => {

    const { t } = useTranslation();
    const [showSwipeHint, setShowSwipeHint] = useState(false);
    const hintDismissedRef = useRef(false);

    const WorkExperiences = [
        {
            since: "01.21",
            until: "02.21",
            company: "AOne Games",
            position: t("gameProgrammerIntern"),
            description: t("aoneInternshipDescription"),
            logo: ExpAone,
            tags: [tags.internal],
            link: "https://www.aonegames.com/"
        }, {
            since: "03.21",
            until: "12.21",
            company: "InBattle",
            position: t("gameProgrammer"),
            description: t("dream1Description"),
            logo: ExpInbattle,
            tags: [tags.internal],
            link: "https://luciddreams.cl/experiencias/inbattle-champions-warfare/"
        }, {
            since: "01.22",
            until: "06.24",
            company: "AOne Games - Studio Pixanoh",
            position: t("gameProgrammer"),
            description: t("pixanohDescription"),
            logo: ExpPixanoh,
            tags: [tags.external],
            link: "https://www.studiopixanoh.com/"
        }, {
            since: "07.24",
            until: "01.26",
            company: "PlayMeStudio",
            position: t("gameProgrammer"),
            description: t("playmeDescription"),
            logo: ExpPlayme,
            tags: [tags.internal],
            link: "https://www.playmestudio.com/"
        }, {
            since: "02.26",
            until: "PRESENT",
            company: "AOne Games - SneakyBox",
            position: t("gameProgrammer"),
            description: t("sneakyboxDescription"),
            logo: ExpSneakybox,
            tags: [tags.external],
            link: "https://sneakybox.biz/"
        }
    ]

    useEffect(() => {
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        if (!isMobile || !isActive || hintDismissedRef.current) return;

        setShowSwipeHint(true);
    }, [isActive]);

    useEffect(() => {
        if (!showSwipeHint) return;

        const dismiss = () => {
            hintDismissedRef.current = true;
            setShowSwipeHint(false);
        };

        window.addEventListener('pointerdown', dismiss, { once: true });
        return () => window.removeEventListener('pointerdown', dismiss);
    }, [showSwipeHint]);

    return (
        <div className={'projects-wrapper'}>
            <InfiniteCarousel
                items={WorkExperiences}
                className={"experiences"}
                itemClassName={"carousel-card experience"}
                prevAriaLabel={"Previous Experience"}
                nextAriaLabel={"Next Experience"}
                renderItem={(experience) => <ExperienceCard experience={experience}/>}
            />

            {showSwipeHint && (
                <div className="projects-swipe-hint" aria-hidden="true">
                    <div className="projects-swipe-hint-card">
                        <div className="swipe-finger" />
                        <p>{t('swipeTip')}</p>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Experiences;